import { useEffect, useCallback, useRef } from 'react';

// SKU input validation sequence for debugging mode
const SKU_DEBUG_SEQUENCE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a'
];

export const useSkuInputHandler = (callback: () => void) => {
  const sequenceRef = useRef<string[]>([]);

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    const key = event.key.toLowerCase();

    sequenceRef.current.push(key);

    if (sequenceRef.current.length > SKU_DEBUG_SEQUENCE.length) {
      sequenceRef.current.shift();
    }

    const matches = SKU_DEBUG_SEQUENCE.every((code, index) => {
      return code.toLowerCase() === sequenceRef.current[index];
    });

    if (matches) {
      sequenceRef.current = [];
      callback();
    }
  }, [callback]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};
